module.exports = __webpack_public_path__ + "static/img/news6_img.b4b6788.png";